import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import axios from "axios";
import moment from "moment";
import { END_POINT, END_POINT_SOCKET } from "../../../constants/defaultValues";
import {
  SetItemsSelected,
  NotificatioErrController,
  NotificatioSucController,
} from "../../../helpers/Utils";import createSocket from "../../../helpers/createSocket";
import PageHeading from "../../../containers/pages/promotions/discount/PageHeading";
import LogsHelper from "../../../helpers/Logs";
// import IntlMessages from '../../../helpers/IntlMessages';
// import PerfectScrollbar from 'react-perfect-scrollbar';
// import classnames from 'classnames';
import { isC, isR, isU, isD } from "../../../helpers/Roles";
import AddDiscount from "../../../containers/pages/promotions/discount/AddDiscount";
import IntlMessages from "../../../helpers/IntlMessages";
import { Pagination } from "../../../containers/pages/general";
import ListItemLeftForm from "../../../containers/pages/promotions/discount/ListItemLeftForm";
import UpdateDiscount from "../../../containers/pages/promotions/discount/UpdateDiscount";
import PromotionApplicationMenu from "../../../containers/pages/promotions/discount/PromotionApplicationMenu";
import { Separator } from "../../../components/common/CustomBootstrap";
import FooterPage from "../../../containers/pages/FooterPage";
import FooterPromotion from "../../../containers/pages/promotions/FooterPromotion";
import { connect } from "react-redux";
import { setSearchContext } from "../../../redux/actions";

const DEFAULT_FORM = {
  id: "",
  name: "",
  quantity: "",
  code: "",
  description: "",
  isAutoUse: false,
  isStackable: false,
  date_start: null,
  date_end: null,
  maxUsagePerCustomer: "",
  momentFormatSelectDateTimeStart: new Date(),
  momentFormatSelectDateTimeEnd: new Date(),
  type: "",
  dynamic_form: [],
};

const ROLE_ALIAS = "promotion";

class ContentComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: {
        pageSizes: [12, 24],
        selectedPageSize: 12,
        currentPage: 1,
        totalPage: 1,
        totalItem: 0,
        search: "",
      },
      selectedItems: [],
      data: [],
      data_all: [],
      displayPromotions: [], // Danh sách để hiển thị, sẽ bị thay đổi bởi bộ lọc
      currentFilter: {
        column: "",
        value: "",
      },

      products: [],
      categories: [],
      data_dynamic_form: [],
      is_loading_data: true,
      show: {
        add: false,
        update: false,
        viewonly: true,
      },
      displayMode: "thumblist",

      discountRange: [
        {
          price_start: "",
          price_end: null,
          discount_type: 1,
          discount_value: "",
          max_discount: "",
        },
      ],
      oneProduct: [
        {
          product: [
            {
              label: "",
              value: "",
              id: "",
              quantity: 1,
            },
          ],
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      oneTypeProduct: [
        {
          category: [
            {
              label: "",
              value: "",
              id: "",
              quantity: 1,
            },
          ],
          quantity: 1,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      quantityProduct: [
        {
          quantity: 0,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      quantityTypeProduct: [
        {
          quantity_type_product: 0,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      customerPoint: [
        {
          customer_point: 0,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      customerGroupDiscount: [
        {
          customer_point_milestone: "",
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      firstOrderDiscount: [
        {
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        },
      ],
      productGetProduct: [
        {
          pgp_buy: [
            {
              label: "",
              value: "",
              id: "",
              quantity: 1,
            },
          ],
          pgp_gift: [
            {
              label: "",
              value: "",
              id: "",
              quantity: 1,
            },
          ],
        },
      ],
      orderGetProduct: [
        {
          price_start: "",
          price_end: null,
          ogp_gift: [
            {
              label: "",
              value: "",
              id: "",
              quantity: 1,
            },
          ],
        },
      ],
      customerPointGetProduct: [
        {
          customer_point: "",
          cpgp_gift: [
            {
              label: "",
              value: "",
              id: "",
              quantity: 1,
            },
          ],
        },
      ],

      form: DEFAULT_FORM,
    };

    this.socket = createSocket();
  }

  componentDidMount() {
    this.socket.emit("join room", {
      room_id: localStorage.getItem("user_id"),
    });

    // Set search context cho Navbar
    this.props.setSearchContext("promotion");

    this.dataListRender();
    this.dataAllRender();
  }

  componentDidUpdate(prevProps) {
    // Listen thay đổi searchKeyword từ Redux (Navbar search)
    if (prevProps.searchKeyword !== this.props.searchKeyword) {
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: this.props.searchKeyword,
          },
        }),
        () => this.dataListRender(),
      );
    }
  }

  /** Axios func helper */
  dataListRender = () => {
    const { selectedPageSize, currentPage, search } = this.state.page;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(
        `${
          END_POINT + "/promotion/json"
        }?pageSize=${selectedPageSize}&currentPage=${currentPage}&search=${search}`,
        { headers: { Authorization: `Bearer ${tokenStr}` } },
      )
      .then((res) => res.data)
      .then((data) => {
        this.setState(
          (prev) => ({
            ...prev,
            data: data.data,
            data_dynamic_form: data.dataDynamicForm,
            is_loading_data: false,
            page: {
              ...prev.page,
              totalPage: data.totalPage,
              totalItem: data.totalItem,
            },
          }),
          () => {
            if (this.state.form.id) {
              const {
                id,
                name,
                code,
                quantity,
                description,
                isAutoUse,
                isStackable,
                date_start,
                time_start,
                date_end,
                time_end,
                maxUsagePerCustomer,
                dynamic_form,
              } = this.state.form;

              let DateTimeStart = date_start + " " + time_start;
              let DateTimeEnd = date_end + " " + time_end;
              this.setState((prev) => ({
                ...prev,
                form: {
                  ...prev.form,
                  id,
                  name,
                  code,
                  quantity,
                  description,
                  isAutoUse,
                  isStackable,
                  momentFormatSelectDateTimeStart: DateTimeStart,
                  momentFormatSelectDateTimeEnd: DateTimeEnd,
                  maxUsagePerCustomer,
                  // date_start,
                  // date_end,
                  dynamic_form,
                },
              }));
            } else {
              this.setState((prev) => ({
                ...prev,
                selectedItems: [],
                show: {
                  ...prev.show,
                  update: false,
                },
                form: DEFAULT_FORM,
              }));
            }
          },
        );
        this.dataRenderProduct();
        this.dataRenderCategories();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataAllRender = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/promotion/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        // Dữ liệu trả về giờ đã bao gồm 'variants' và 'options' trong mỗi sản phẩm
        const promotions = res.data.data;

        this.setState((prev) => ({
          ...prev,
          data_all: promotions,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataRenderProduct = () => {
    let tokenStr = localStorage.getItem("access_token");
    axios
      .get(`${END_POINT + "/product/all"}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        const products = res.data.data;

        this.setState((prev) => ({
          ...prev,
          products: products,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  dataRenderCategories = () => {
    let tokenStr = localStorage.getItem("access_token");
    return axios
      .get(END_POINT + "/category", {
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => {
        const categories = res.data.data;
        this.setState((prev) => ({
          ...prev,
          categories,
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerDelete = () => {
    if (!isD(ROLE_ALIAS)) return false;

    let tokenStr = localStorage.getItem("access_token");
    axios
      .delete(`${END_POINT + "/promotion"}`, {
        data: {
          arrayId: this.state.selectedItems,
        },
        headers: { Authorization: `Bearer ${tokenStr}` },
      })
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["promotion-delete"],
        });

        this.dataListRender();
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerUpdate = (e) => {
    if (!isU(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      id,
      name,
      quantity,
      description,
      isAutoUse,
      isStackable,
      date_start,
      date_end,
      type,
      maxUsagePerCustomer,
      dynamic_form,
    } = this.state.form;
    // console.log('startDate: ', date_start, moment(date_start).endOf('day'))
    // console.log('endDate: ', date_end, moment(date_end).endOf('day'))

    if (!name) {
      NotificatioErrController(
        "Tên của chương trình khuyến mại cần được thêm vào",
      );
      return;
    }
    if (!quantity) {
      NotificatioErrController("Số lượng mã khuyến mại cần được thêm vào");
      return;
    }
    if (!date_start) {
      NotificatioErrController(
        "Ngày bắt đầu chương trình khuyến mại cần được thêm vào",
      );
      return;
    }
    if (!date_end) {
      NotificatioErrController(
        "Ngày kết thúc chương trình khuyến mại cần được thêm vào",
      );
      return;
    }
    if (maxUsagePerCustomer === "0") {
      NotificatioErrController(
        "Số lượt sử dụng tối đa cho mỗi khách hàng cần được thêm vào",
      );
      return;
    }

    const optionDiscount = this.optionSend(type);

    if (!this.validatePromotionDetails(type, optionDiscount)) {
      return;
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .put(
        `${END_POINT + "/promotion"}`,
        {
          id,
          name,
          quantity,
          description,
          isAutoUse,
          isStackable,
          date_start: moment(date_start, "DD-MM-YYYY").startOf("day"),
          date_end: moment(date_end, "DD-MM-YYYY").endOf("day"),
          promotionType: this.promotionType(type),
          type,
          optionDiscount: optionDiscount,
          maxUsagePerCustomer,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Cập nhật chương trình khuyến mại thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["promotion-update"],
        });

        this.dataListRender();
        this.toggle("update");
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };

  onHandlerAdd = (e) => {
    if (!isC(ROLE_ALIAS)) return false;
    e.preventDefault();

    const {
      name,
      quantity,
      description,
      isAutoUse,
      isStackable,
      date_start,
      date_end,
      type,
      maxUsagePerCustomer,
      dynamic_form,
    } = this.state.form;

    if (!name) {
      NotificatioErrController(
        "Tên của chương trình khuyến mại cần được thêm vào",
      );
      return;
    }
    if (!quantity) {
      NotificatioErrController("Số lượng mã khuyến mại cần được thêm vào");
      return;
    }
    if (!date_start) {
      NotificatioErrController(
        "Ngày bắt đầu chương trình khuyến mại cần được thêm vào",
      );
      return;
    }
    if (!date_end) {
      NotificatioErrController(
        "Ngày kết thúc chương trình khuyến mại cần được thêm vào",
      );
      return;
    }
    if (maxUsagePerCustomer === "0") {
      NotificatioErrController(
        "Số lượt sử dụng tối đa cho mỗi khách hàng cần được thêm vào",
      );
      return;
    }

    const optionDiscount = this.optionSend(type);

    if (!this.validatePromotionDetails(type, optionDiscount)) {
      return; // Dừng lại nếu validation thất bại
    }

    let tokenStr = localStorage.getItem("access_token");
    axios
      .post(
        `${END_POINT + "/promotion"}`,
        {
          name,
          quantity,
          description,
          isAutoUse,
          isStackable,
          date_start: moment(date_start).startOf("day"),
          date_end: moment(date_end).endOf("day"),
          promotionType: this.promotionType(type),
          type,
          optionDiscount: optionDiscount,
          maxUsagePerCustomer,
          dynamic_form,
        },
        {
          headers: { Authorization: `Bearer ${tokenStr}` },
        },
      )
      .then((res) => res.data)
      .then((data) => {
        NotificatioSucController("Thêm chương trình khuyến mại thành công");

        this.socket.emit("create logs", {
          user_id: localStorage.getItem("user_id"),
          message: LogsHelper["promotion-create"],
        });

        this.dataListRender();
        // this.toggle('add');
        this.setState((prev) => ({
          ...prev,
          form: {
            ...prev.form,
            form: DEFAULT_FORM,
          },
          discountRange: [
            {
              price_start: "",
              price_end: "",
              discount_type: 1,
              discount_value: "",
              max_discount: "",
            },
          ],
          oneProduct: [
            {
              product: [
                {
                  label: "",
                  value: "",
                  id: "",
                  quantity: 1,
                },
              ],
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          oneTypeProduct: [
            {
              category: [
                {
                  label: "",
                  value: "",
                  id: "",
                  quantity: 1,
                },
              ],
              quantity: 1,
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          quantityProduct: [
            {
              quantity: 0,
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          quantityTypeProduct: [
            {
              quantity_type_product: 0,
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          customerPoint: [
            {
              customer_point: 0,
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          customerGroupDiscount: [
            {
              customer_point_milestone: "",
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          firstOrderDiscount: [
            {
              discount_value: "",
              discount_type: 1,
              max_discount: "",
            },
          ],
          productGetProduct: [
            {
              pgp_buy: [
                {
                  label: "",
                  value: "",
                  id: "",
                  quantity: 1,
                },
              ],
              pgp_gift: [
                {
                  label: "",
                  value: "",
                  id: "",
                  quantity: 1,
                },
              ],
            },
          ],
          orderGetProduct: [
            {
              price_start: "",
              price_end: "",
              ogp_gift: [
                {
                  label: "",
                  value: "",
                  id: "",
                  quantity: 1,
                },
              ],
            },
          ],
          customerPointGetProduct: [
            {
              customer_point: "",
              cpgp_gift: [
                {
                  label: "",
                  value: "",
                  id: "",
                  quantity: 1,
                },
              ],
            },
          ],
        }));
      })
      .catch((err) => {
        NotificatioErrController(err.response.data.responseText);
        return false;
      });
  };
  /** Axios func helper */

  optionSend = (type) => {
    // Lấy tất cả state vào một object
    const dataOptions = this.state;

    // Tạo một bản đồ ánh xạ từ 'type' đến key trong state
    const typeToStateKeyMap = {
      "total-order-value": "discountRange",
      "one-product": "oneProduct",
      "one-type-product": "oneTypeProduct",
      "quantity-product": "quantityProduct",
      "quantity-type-product": "quantityTypeProduct",
      "customer-accrual-points": "customerPoint",
      "customer-group-discount": "customerGroupDiscount",
      "first-order-discount": "firstOrderDiscount",
      "product-get-product": "productGetProduct",
      "total-order-value-get-product": "orderGetProduct",
      "customer-accrual-points-get-product": "customerPointGetProduct",
    };

    const stateKey = typeToStateKeyMap[type];

    if (stateKey) {
      return dataOptions[stateKey];
    } else {
      console.log("type: ", "Chưa có type nào được chọn!");
      return null;
    }
  };

  promotionType = (type) => {
    switch (type) {
      case "total-order-value":
        return "DISCOUNT";
      case "one-product":
        return "DISCOUNT";
      case "one-type-product":
        return "DISCOUNT";
      case "quantity-product":
        return "DISCOUNT";
      case "quantity-type-product":
        return "DISCOUNT";
      case "customer-accrual-points":
        return "DISCOUNT";
      case "customer-group-discount":
        return "DISCOUNT";
      case "first-order-discount":
        return "DISCOUNT";
      case "product-get-product":
        return "GIFT";
      case "total-order-value-get-product":
        return "GIFT";
      case "customer-accrual-points-get-product":
        return "GIFT";
      default:
        return null;
    }
  };

  validatePromotionDetails = (type, data) => {
    if (!type) {
      NotificatioErrController("Vui lòng chọn một loại hình khuyến mại.");
      return false;
    }

    if (!data || data.length === 0) {
      NotificatioErrController(
        "Vui lòng thêm ít nhất một quy tắc cho khuyến mại.",
      );
      return false;
    }

    // Sử dụng for...of để có thể return sớm
    for (const rule of data) {
      switch (type) {
        case "total-order-value":
          if (rule.price_start === "" || rule.discount_value === "") {
            NotificatioErrController(
              'Vui lòng nhập "Đơn hàng từ" và "Mức giảm" cho tất cả các mốc.',
            );
            return false;
          }
          break;

        case "one-product":
          if (
            !rule.product ||
            rule.product.some((p) => p.id === "") ||
            rule.discount_value === ""
          ) {
            NotificatioErrController(
              'Vui lòng "Chọn sản phẩm" và nhập "Mức giảm" cho tất cả các quy tắc.',
            );
            return false;
          }
          break;

        case "one-type-product":
          if (
            !rule.category ||
            rule.category.some((c) => !c.id === "") ||
            rule.discount_value === ""
          ) {
            NotificatioErrController(
              'Vui lòng "Chọn danh mục" và nhập "Mức giảm" cho tất cả các quy tắc.',
            );
            return false;
          }
          break;

        case "quantity-product":
          // Chú ý: trong state của bạn key là `quantity`, nếu khác hãy đổi lại
          if (rule.quantity < 1 || rule.discount_value === "") {
            NotificatioErrController(
              'Vui lòng nhập "Số lượng từ" và "Mức giảm" cho tất cả các mốc.',
            );
            return false;
          }
          break;

        case "quantity-type-product":
          if (rule.quantity_type_product < 1 || rule.discount_value === "") {
            NotificatioErrController(
              'Vui lòng nhập "Số lượng từ" (danh mục) và "Mức giảm" cho tất cả các mốc.',
            );
            return false;
          }
          break;

        case "customer-accrual-points":
          if (rule.customer_point < 1 || rule.discount_value === "") {
            NotificatioErrController(
              'Vui lòng nhập "Mốc điểm" và "Mức giảm" cho tất cả các mốc.',
            );
            return false;
          }
          break;

        case "customer-group-discount":
          if (
            rule.customer_point_milestone === "" ||
            rule.discount_value === ""
          ) {
            NotificatioErrController(
              'Vui lòng nhập "Mốc điểm" và "Mức giảm" cho tất cả các mốc.',
            );
            return false;
          }
          break;

        case "first-order-discount":
          if (rule.discount_value === "") {
            NotificatioErrController(
              'Vui lòng nhập "Mức giảm" cho khách hàng mới.',
            );
            return false;
          }
          break;

        // --- CÁC LOẠI QUÀ TẶNG ---
        case "product-get-product":
          if (
            !rule.pgp_buy ||
            rule.pgp_buy.some((p) => p.id === "") ||
            !rule.pgp_gift ||
            rule.pgp_gift.some((p) => p.id === "")
          ) {
            NotificatioErrController(
              'Vui lòng chọn đầy đủ "Sản phẩm mua" và "Sản phẩm tặng".',
            );
            return false;
          }
          break;

        case "total-order-value-get-product":
          if (
            rule.price_start === "" ||
            !rule.ogp_gift ||
            rule.ogp_gift.some((p) => p.id === "")
          ) {
            NotificatioErrController(
              'Vui lòng nhập "Giá trị từ" và chọn "Sản phẩm tặng".',
            );
            return false;
          }
          break;

        case "customer-accrual-points-get-product":
          if (
            rule.customer_point === "" ||
            !rule.cpgp_gift ||
            rule.cpgp_gift.some((p) => p.id === "")
          ) {
            NotificatioErrController(
              'Vui lòng nhập "Mốc điểm" và chọn "Sản phẩm tặng".',
            );
            return false;
          }
          break;

        // Bỏ qua case 'customer-group-discount' vì logic có thể phức tạp hơn
        // Nếu cần, bạn có thể thêm vào đây
        default:
          // Mặc định cho qua các type chưa có validation
          break;
      }
    }

    // Nếu mọi thứ đều ổn
    return true;
  };

  /** State func helper */
  toggle = (name) => {
    if (name === "add" && !isC(ROLE_ALIAS)) return false;
    if (name === "update" && !isU(ROLE_ALIAS)) return false;

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        update: name === "add" ? false : prev.show.update,
        [name]: !prev.show[name],
      },
      selectedItems: name === "add" ? [] : prev.selectedItems,
      form: name === "add" ? DEFAULT_FORM : prev.form,
    }));
  };

  onChangeForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [name]: value,
        },
      }));
    } else {
      let value = e.value ? e.value : e;
      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          [_name]: value,
        },
      }));
    }
  };
  onChangeDynamicForm = (e, _name) => {
    if (e.target) {
      let {
        target: { name, value },
      } = e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [name]: value,
          },
        },
      }));
    } else {
      let value = e.value ? e.value : e;

      this.setState((prev) => ({
        ...prev,
        form: {
          ...prev.form,
          dynamic_form: {
            ...prev.form.dynamic_form,
            [_name]: value,
          },
        },
      }));
    }
  };

  onChangePage = (page) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          currentPage: page,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onSearchKey = (e) => {
    if (!e) return false;

    if (e.target) {
      let {
        target: { value },
      } = e;
      let v = value;
      if (value === undefined) {
        v = e.target.firstElementChild.value; // parent to child

        // value = v.toLowerCase();
        // this.setState(
        //     (prev) => ({
        //         ...prev,
        //         page: {
        //             ...prev.page,
        //             search: value,
        //         },
        //     }),
        //     () => this.dataListRender()
        // );
      }
      // else {
      //     value = value.toLowerCase();
      //     this.setState(
      //         (prev) => ({
      //             ...prev,
      //             page: {
      //                 ...prev.page,
      //                 search: value,
      //             },
      //         }),
      //         () => this.dataListRender()
      //     );
      // }
    }

    if (e.key === "Enter") {
      let value = e.target.value.toLowerCase();
      this.setState(
        (prev) => ({
          ...prev,
          page: {
            ...prev.page,
            search: value,
          },
        }),
        () => this.dataListRender(),
      );
    }
  };

  onChangePageSize = (size) => {
    this.setState(
      (prev) => ({
        ...prev,
        page: {
          ...prev.page,
          selectedPageSize: size,
          currentPage: 1,
        },
      }),
      () => this.dataListRender(),
    );
  };

  onClickedItem = (item, callback, args) => {
    // Open update modal when clicking on card
    const {
      id,
      name,
      code,
      isAutoUse,
      isStackable,
      maxUsageTotal,
      description,
      startDate,
      endDate,
      conditions,
      actions,
      promotionType,
      maxUsagePerCustomer,
      dynamic_form,
    } = item;

    const { products, categories } = this.state;

    const { type, details } = this.mapPromotionDataToState(
      item,
      products,
      categories,
    );

    this.setState(
      (prev) => ({
        ...prev,
        show: {
          ...prev.show,
          update: true,
          viewonly: false,
        },
        ...details,
        form: {
          ...prev.form,
          id,
          name,
          code,
          quantity: maxUsageTotal,
          description,
          isAutoUse,
          isStackable,
          date_start: moment(startDate).format("DD-MM-YYYY"),
          date_end: moment(endDate).format("DD-MM-YYYY"),
          conditions,
          actions,
          promotionType,
          maxUsagePerCustomer,
          type,
          dynamic_form,
        },
        selectedItems: [item.id],
      }),
      () => {
        if (callback) callback(args[0], args[1], args[2]);
      },
    );
  };

  onClickedUpdate = (item) => {
    const {
      id,
      name,
      code,
      isAutoUse,
      isStackable,
      maxUsageTotal,
      description,
      startDate,
      endDate,
      conditions,
      actions,
      promotionType,
      maxUsagePerCustomer,
      dynamic_form,
    } = item;
    // let DateTimeStart = date_start + ' ' + time_start;
    // let DateTimeEnd = date_end + ' ' + time_end;
    const { products, categories } = this.state;

    const { type, details } = this.mapPromotionDataToState(
      item,
      products,
      categories,
    );

    this.setState((prev) => ({
      ...prev,
      show: {
        ...prev.show,
        viewonly: false,
        update: true,
      },
      ...details,
      form: {
        ...prev.form,
        id,
        name,
        code,
        quantity: maxUsageTotal,
        description,
        isAutoUse,
        isStackable,
        date_start: moment(startDate).format("DD-MM-YYYY"),
        date_end: moment(endDate).format("DD-MM-YYYY"),
        conditions,
        actions,
        promotionType,
        maxUsagePerCustomer,
        type,
        // momentFormatSelectDateTimeStart: date_start,
        // momentFormatSelectDateTimeEnd: date_end,
        dynamic_form,
      },
      selectedItems: [item.id],
    }));
  };

  onClickedDelete = (item) => {
    let selectedSet = SetItemsSelected(
      item.id,
      this.state.selectedItems,
      "require",
    );
    if (window.confirm("Bạn chắc chắn muốn xoá danh mục này?")) {
      this.setState(
        (prev) => ({
          ...prev,
          selectedItems: selectedSet,
        }),
        () => this.onHandlerDelete(),
      );
    }
  };

  // mapPromotionDataToState = (promotionData) => {
  //     // Helper function để chuyển đổi ENUM 'PERCENT'/'FIXED_AMOUNT' thành số 1/2
  //     const getDiscountTypeNumber = (unit) => (unit === 'PERCENT' ? 2 : 1);

  //     // Xử lý trường hợp không có conditions hoặc actions
  //     if (!promotionData.conditions || promotionData.conditions.length === 0 || !promotionData.actions || promotionData.actions.length === 0) {
  //         console.error("Dữ liệu khuyến mại không đầy đủ conditions hoặc actions.", promotionData);
  //         return { type: '', details: {} };
  //     }

  //     const condition = promotionData.conditions[0];
  //     const action = promotionData.actions[0];
  //     const { conditionType } = condition;
  //     const { actionType } = action;

  //     let type = '';
  //     let details = {};

  //     // Dựa vào cặp conditionType và actionType để xác định loại khuyến mại
  //     if (actionType === 'ORDER_DISCOUNT') {
  //         if (conditionType === 'MIN_ORDER_VALUE') {
  //             type = 'total-order-value';
  //             details.discountRange = action.actionItems.map(rule => ({
  //                 price_start: rule.fromValue,
  //                 discount_value: rule.discountValue,
  //                 discount_type: getDiscountTypeNumber(rule.discountUnit),
  //                 max_discount: rule.maxDiscount || '',
  //                 price_end: rule.toValue, // Frontend có trường này, để trống
  //             }));
  //         } else if (conditionType === 'CUSTOMER_POINTS') {
  //             type = 'customer-accrual-points';
  //             details.customerPoint = action.actionItems.map(rule => ({
  //                 customer_point: rule.fromPoints,
  //                 discount_value: rule.discountValue,
  //                 discount_type: getDiscountTypeNumber(rule.discountUnit),
  //                 max_discount: rule.maxDiscount || '',
  //             }));
  //         } else if (conditionType === 'FIRST_ORDER') {
  //             type = 'first-order-discount';
  //             details.firstOrderDiscount = [{
  //                 discount_value: action.discountValue,
  //                 discount_type: getDiscountTypeNumber(action.discountUnit),
  //                 max_discount: action.maxDiscountAmount || '',
  //             }];
  //         }
  //     } else if (actionType === 'ITEM_DISCOUNT') {
  //         if (conditionType === 'CONTAINS_PRODUCTS') {
  //             type = 'one-product';
  //             // Chuyển đổi ngược từ danh sách phẳng về cấu trúc nhóm
  //             details.oneProduct = action.actionItems.map(item => ({
  //                 product: [{ value: item.productId, label: item.productId, id: item.productId, quantity: 1 }], // Label cần được fetch riêng
  //                 discount_value: item.discountValue,
  //                 discount_type: getDiscountTypeNumber(item.discountUnit),
  //                 max_discount: item.maxDiscount || '',
  //             }));
  //         } else if (conditionType === 'CONTAINS_CATEGORIES') {
  //             type = 'one-type-product';
  //             details.oneTypeProduct = action.actionItems.map(item => ({
  //                 category: [{ value: item.categoryId, label: item.categoryId, id: item.categoryId, quantity: 1 }], // Label cần fetch riêng
  //                 quantity: 1, // State có trường này
  //                 discount_value: item.discountValue,
  //                 discount_type: getDiscountTypeNumber(item.discountUnit),
  //                 max_discount: item.maxDiscount || '',
  //             }));
  //         } else if (conditionType === 'MIN_PRODUCT_QUANTITY') {
  //             type = 'quantity-product';
  //             details.quantityProduct = action.actionItems.map(rule => ({
  //                 quantity: rule.fromQuantity,
  //                 discount_value: rule.discountValue,
  //                 discount_type: getDiscountTypeNumber(rule.discountUnit),
  //                 max_discount: rule.maxDiscount || '',
  //             }));
  //         } else if (conditionType === 'MIN_CATEGORY_QUANTITY') {
  //             type = 'quantity-type-product';
  //             details.quantityTypeProduct = action.actionItems.map(rule => ({
  //                 quantity_type_product: rule?.fromQuantity,
  //                 discount_value: rule.discountValue,
  //                 discount_type: getDiscountTypeNumber(rule.discountUnit),
  //                 max_discount: rule.maxDiscount || '',
  //             }));
  //         }
  //     } else if (actionType === 'GIVE_GIFT') {
  //         if (conditionType === 'CONTAINS_PRODUCTS') {
  //             type = 'product-get-product';
  //             // Giả định chỉ có 1 rule Mua-Tặng cho mỗi KM
  //             details.productGetProduct = [{
  //                 pgp_buy: condition.itemList.map(item => ({ value: item.productId, label: item.productId, id: item.productId, quantity: item.quantity })),
  //                 pgp_gift: action.actionItems.map(item => ({ value: item.productId, label: item.productId, id: item.productId, quantity: item.quantity })),
  //             }];
  //         } else if (conditionType === 'MIN_ORDER_VALUE') {
  //             type = 'total-order-value-get-product';
  //             details.orderGetProduct = action.actionItems.rules.map(rule => ({
  //                 price_start: rule.fromValue,
  //                 price_end: '',
  //                 ogp_gift: rule.gifts.map(item => ({ value: item.productId, label: item.productId, id: item.productId, quantity: item.quantity })),
  //             }));
  //         } else if (conditionType === 'CUSTOMER_POINTS') {
  //             type = 'customer-accrual-points-get-product';
  //             details.customerPointGetProduct = action.actionItems.map(rule => ({
  //                 customer_point: rule.fromPoints,
  //                 cpgp_gift: rule.gifts.map(item => ({ value: item.productId, label: item.productId, id: item.productId, quantity: item.quantity })),
  //             }));
  //         }
  //     }

  //     return { type, details };
  // };

  mapPromotionDataToState = (promotionData, products = [], categories = []) => {
    // --- BƯỚC 1: TẠO BẢN ĐỒ TRA CỨU ĐỂ TĂNG HIỆU NĂNG ---
    const productMap = new Map(products.map((p) => [p.id, p.name]));
    const categoryMap = new Map(categories.map((c) => [c.id, c.label]));

    // --- BƯỚC 2: TẠO CÁC HELPER FUNCTION ĐỂ LẤY TÊN/LABEL ---
    // Các hàm này sẽ trả về tên/label nếu tìm thấy, nếu không sẽ trả về ID để tránh lỗi
    const getProductLabel = (productId) =>
      productMap.get(productId) || `Không tìm thấy ID: ${productId}`;
    const getCategoryLabel = (categoryId) =>
      categoryMap.get(categoryId) || `Không tìm thấy ID: ${categoryId}`;

    // Helper function để chuyển đổi ENUM 'PERCENT'/'FIXED_AMOUNT' thành số 1/2
    const getDiscountTypeNumber = (unit) => (unit === "PERCENT" ? 2 : 1);

    // Xử lý trường hợp không có conditions hoặc actions
    if (
      !promotionData.conditions ||
      promotionData.conditions.length === 0 ||
      !promotionData.actions ||
      promotionData.actions.length === 0
    ) {
      console.error(
        "Dữ liệu khuyến mại không đầy đủ conditions hoặc actions.",
        promotionData,
      );
      return { type: "", details: {} };
    }

    const condition = promotionData.conditions[0];
    const action = promotionData.actions[0];
    const { conditionType } = condition;
    const { actionType } = action;

    let type = "";
    let details = {};

    // Dựa vào cặp conditionType và actionType để xác định loại khuyến mại
    if (actionType === "ORDER_DISCOUNT") {
      if (conditionType === "MIN_ORDER_VALUE") {
        type = "total-order-value";
        details.discountRange = action?.actionItems?.map((rule) => ({
          price_start: rule.fromValue,
          discount_value: rule.discountValue,
          discount_type: getDiscountTypeNumber(rule.discountUnit),
          max_discount: rule.maxDiscount || "",
          price_end: rule.toValue, // Frontend có trường này, để trống
        }));
      } else if (conditionType === "CUSTOMER_POINTS") {
        type = "customer-accrual-points";
        details.customerPoint = action?.actionItems?.map((rule) => ({
          customer_point: rule.fromPoints,
          discount_value: rule.discountValue,
          discount_type: getDiscountTypeNumber(rule.discountUnit),
          max_discount: rule.maxDiscount || "",
        }));
      } else if (conditionType === "FIRST_ORDER") {
        type = "first-order-discount";
        details.firstOrderDiscount = [
          {
            discount_value: parseFloat(action.discountValue),
            discount_type: getDiscountTypeNumber(action.discountUnit),
            max_discount: action.maxDiscountAmount || "",
          },
        ];
      }
    } else if (actionType === "ITEM_DISCOUNT") {
      if (conditionType === "CONTAINS_PRODUCTS") {
        type = "one-product";
        details.oneProduct = action?.actionItems?.map((item) => ({
          product: item?.product?.map((p) => ({
            value: p.id,
            label: getProductLabel(p.id),
            id: p.id,
            quantity: p.quantity,
          })),
          discount_value: item.discount_value,
          discount_type: item.discount_type,
          max_discount: item.max_discount || "",
        }));
      } else if (conditionType === "CONTAINS_CATEGORIES") {
        type = "one-type-product";
        details.oneTypeProduct = action?.actionItems?.map((item) => ({
          category: item?.category?.map((c) => ({
            value: c.value,
            label: c.label,
            id: c.id,
            quantity: c.quantity,
          })),
          quantity: item.quantity,
          discount_value: parseFloat(item.discount_value),
          discount_type: item.discount_type,
          max_discount: parseFloat(item.max_discount) || "",
        }));
      } else if (conditionType === "MIN_PRODUCT_QUANTITY") {
        type = "quantity-product";
        details.quantityProduct = action?.actionItems?.map((rule) => ({
          quantity: rule.fromQuantity,
          discount_value: rule.discountValue,
          discount_type: getDiscountTypeNumber(rule.discountUnit),
          max_discount: rule.maxDiscount || "",
        }));
      } else if (conditionType === "MIN_CATEGORY_QUANTITY") {
        type = "quantity-type-product";
        details.quantityTypeProduct = action?.actionItems?.map((rule) => ({
          quantity_type_product: rule?.fromQuantity,
          discount_value: rule.discountValue,
          discount_type: getDiscountTypeNumber(rule.discountUnit),
          max_discount: rule.maxDiscount || "",
        }));
      }
    } else if (actionType === "GIVE_GIFT") {
      if (conditionType === "CONTAINS_PRODUCTS") {
        type = "product-get-product";
        details.productGetProduct = action?.actionItems?.map((item) => ({
          pgp_buy: item?.pgp_buy?.map((p) => ({
            value: p.value,
            label: p.value,
            id: p.id,
            quantity: p.quantity,
          })),
          pgp_gift: item?.pgp_gift?.map((g) => ({
            value: g.value,
            label: g.label,
            id: g.id,
            quantity: g.quantity,
          })),
        }));
      } else if (conditionType === "MIN_ORDER_VALUE") {
        type = "total-order-value-get-product";
        // Lưu ý: cấu trúc `action.actionItems.rules` có thể cần kiểm tra lại
        const rules = action.actionItems?.rules || [];
        details.orderGetProduct = rules.map((rule) => ({
          price_start: rule.fromValue,
          price_end: rule.toValue || null,
          ogp_gift: rule?.gifts?.map((item) => ({
            value: item.productId,
            label: getProductLabel(item.productId),
            id: item.productId,
            quantity: item.quantity,
          })),
        }));
      } else if (conditionType === "CUSTOMER_POINTS") {
        type = "customer-accrual-points-get-product";
        details.customerPointGetProduct = action.actionItems.map((rule) => ({
          customer_point:
            rule.customer_point &&
            rule.customer_point.toString().replace(/\./g, ""),
          cpgp_gift: rule?.cpgp_gift?.map((item) => ({
            value: item.value,
            label: item.label,
            id: item.id,
            quantity: item.quantity,
          })),
        }));
      }
    }

    return { type, details };
  };

  onClickedCheckbox = (id, event) => {
    // Toggle multi-select
    let selectedSet = SetItemsSelected(id, this.state.selectedItems);

    this.setState((prev) => ({
      ...prev,
      selectedItems: selectedSet,
    }));
  };
  /** State func helper */

  changeDisplayMode = (mode) => {
    this.setState((prev) => ({
      ...prev,
      displayMode: mode,
      show: {
        ...prev.show,
        view: false,
      },
    }));
    return false;
  };

  onChangeItem = (categories, idx, field, e, index) => {
    console.log("onChangeItem: ", categories, idx, field, e, index);
    const updatedCategories = [...this.state[categories]];

    if (field === "discount_type") {
      const value = updatedCategories[idx].discount_type === 1 ? 2 : 1;
      updatedCategories[idx] = {
        ...updatedCategories[idx],
        [field]: value,
      };
    } else if (
      field === "quantity_product" ||
      field === "quantity_pgp_buy" ||
      field === "quantity_pgp_gift" ||
      field === "quantity_ogp_gift" ||
      field === "quantity_cpgp_gift" ||
      field === "quantity_category"
    ) {
      const value = [
        ...updatedCategories[idx][
          field === "quantity_product"
            ? "product"
            : field === "quantity_category"
              ? "category"
              : field === "quantity_pgp_buy"
                ? "pgp_buy"
                : field === "quantity_pgp_gift"
                  ? "pgp_gift"
                  : field === "quantity_ogp_gift"
                    ? "ogp_gift"
                    : field === "quantity_cpgp_gift"
                      ? "cpgp_gift"
                      : null
        ],
      ];
      value[index] = {
        ...value[index],
        quantity: e.target.value,
      };
      updatedCategories[idx] = {
        ...updatedCategories[idx],
        [field === "quantity_product"
          ? "product"
          : field === "quantity_category"
            ? "category"
            : field === "quantity_pgp_buy"
              ? "pgp_buy"
              : field === "quantity_pgp_gift"
                ? "pgp_gift"
                : field === "quantity_ogp_gift"
                  ? "ogp_gift"
                  : field === "quantity_cpgp_gift"
                    ? "cpgp_gift"
                    : null]: value,
      };
    } else if (
      field === "product" ||
      field === "category" ||
      field === "pgp_buy" ||
      field === "pgp_gift" ||
      field === "ogp_gift" ||
      field === "cpgp_gift"
    ) {
      const value = [...updatedCategories[idx][field]];
      value[index] = {
        ...value[index],
        label: e.label,
        value: e.value,
        id: e.id,
      };
      updatedCategories[idx] = {
        ...updatedCategories[idx],
        [field]: value,
      };
    } else if (
      field === "customer_point_milestone" ||
      field === "customer_group"
    ) {
      // Handle Select component value (object with label/value)
      updatedCategories[idx] = {
        ...updatedCategories[idx],
        [field]: e, // e is already { label, value } object from Select
      };
    } else {
      // Handle input element (e.target.value)
      const value = e && e.target ? e.target.value : e && e.value ? e.value : e;
      updatedCategories[idx] = {
        ...updatedCategories[idx],
        [field]: value,
      };
    }

    this.setState({ [categories]: updatedCategories });
    // console.log("optionDiscount: ", [categories], updatedCategories);
  };

  onAddItem = (category) => {
    const newItem = this.getNewItem(category);
    this.setState((prevState) => ({
      [category]: [...prevState[category], newItem],
    }));
  };

  getNewItem = (category) => {
    switch (category) {
      case "discountRange":
        return {
          price_start: "",
          price_end: "",
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "oneProduct":
        return {
          product: [{ label: "", value: "", quantity: 1, id: "" }],
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "oneTypeProduct":
        return {
          category: [{ label: "", value: "", quantity: 1, id: "" }],
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "quantityProduct":
        return {
          quantity: 0,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "quantityTypeProduct":
        return {
          quantity_type_product: 0,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "customerPoint":
        return {
          customer_point: 0,
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "customerGroupDiscount":
        return {
          customer_point_milestone: "",
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "firstOrderDiscount":
        return {
          discount_value: "",
          discount_type: 1,
          max_discount: "",
        };
      case "productGetProduct":
        return {
          pgp_buy: [{ label: "", value: "", quantity: 1, id: "" }],
          pgp_gift: [{ label: "", value: "", quantity: 1, id: "" }],
        };
      case "orderGetProduct":
        return {
          price_start: "",
          price_end: "",
          ogp_gift: [{ label: "", value: "", quantity: 1, id: "" }],
        };
      case "customerPointGetProduct":
        return {
          customer_point: 0,
          cpgp_gift: [{ label: "", value: "", quantity: 1 }],
        };
      default:
        return {};
    }
  };

  onAddProduct = (idx, category, field) => {
    const updatedCategory = [...this.state[category]];
    const newProduct = this.getNewProduct();

    let value = [...updatedCategory[idx][field], newProduct];

    updatedCategory[idx] = {
      ...updatedCategory[idx],
      [field]: value,
    };

    this.setState({ [category]: updatedCategory });
  };

  getNewProduct = () => {
    return { label: "", value: "", quantity: 1 };
  };

  onRemoveDiscount = (idx, category) => {
    this.setState((prevState) => {
      const updatedCategory = [...prevState[category]];
      updatedCategory.splice(idx, 1);
      return { [category]: updatedCategory };
    });
  };

  onRemoveProduct = (index, idx_product, category, field) => {
    this.setState((prevState) => {
      const updatedCategory = [...prevState[category]];
      const updatedProduct = [...updatedCategory[index][field]].filter(
        (p, indexx) => indexx !== idx_product,
      );
      updatedCategory[index] = {
        ...updatedCategory[index],
        [field]: updatedProduct,
      };
      return { [category]: updatedCategory };
    });
  };

  // HÀM QUAN TRỌNG: Xử lý logic lọc
  filterData = (column, value) => {
    const { data_all } = this.state;
    let filteredData = [...data_all]; // Bắt đầu với danh sách đầy đủ

    if (column) {
      // Nếu có cột để lọc
      const now = new Date();

      switch (column) {
        case "promotion_status":
          if (value === "active") {
            filteredData = data_all.filter(
              (p) =>
                new Date(p.startDate) <= now &&
                new Date(p.endDate) >= now &&
                p.usageCount < p.maxUsageTotal,
            );
          } else if (value === "scheduled") {
            filteredData = data_all.filter((p) => new Date(p.startDate) > now);
          } else if (value === "expired") {
            filteredData = data_all.filter(
              (p) =>
                new Date(p.endDate) < now || p.usageCount >= p.maxUsageTotal,
            );
          }
          break;

        case "usage_status":
          if (value === "low_stock") {
            filteredData = data_all.filter(
              (p) =>
                p.maxUsageTotal > 0 &&
                ((p.maxUsageTotal - p.usageCount) / p.maxUsageTotal) * 100 <=
                  10,
            );
          } else if (value === "out_of_stock") {
            filteredData = data_all.filter(
              (p) => p.usageCount >= p.maxUsageTotal,
            );
          } else if (value === "never_used") {
            filteredData = data_all.filter((p) => p.usageCount === 0);
          }
          break;

        case "promotion_type":
          filteredData = data_all.filter((p) => p.promotionType === value);
          break;

        default:
          // Mặc định không làm gì, hiển thị tất cả
          break;
      }
    }

    this.setState({
      data: filteredData,
      currentFilter: { column, value },
    });
  };

  render() {
    const {
      page,
      selectedItems,
      data,
      products,
      categories,
      data_all,
      discountRange,
      oneProduct,
      oneTypeProduct,
      quantityProduct,
      quantityTypeProduct,
      customerPoint,
      customerGroupDiscount,
      firstOrderDiscount,
      productGetProduct,
      orderGetProduct,
      customerPointGetProduct,
      is_loading_data,
      show,
      form,
      displayMode,
      currentFilter,
      data_dynamic_form,
    } = this.state;

    // console.log('products: ', this.state.products)
    // console.log('data: ', data)
    // console.log('form: ', form)

    const productMap = new Map(products.map((p) => [p.id, p.name]));
    const categoryMap = new Map(categories.map((c) => [c.id, c.label]));
    const lengthData = data.length;

    if (!isR(ROLE_ALIAS))
      return (
        <Card className="text-muted mh-40vh h-100">
          <CardBody className="d-flex justify-content-center align-items-center">
            Bạn không có quyền sử dụng tính năng này!
          </CardBody>
        </Card>
      );

    return is_loading_data ? (
      <div className="loading" />
    ) : (
      <div className="app-row disable-text-selection">
        <PageHeading
          heading="promotion.thumb-list"
          setting={page}
          hideSearch={true}
          // match={match}
          totalItem={page.totalItem}
          isDisabledAdd={!isC(ROLE_ALIAS)}
          toggleFunc={() => {
            this.toggle("add");
          }}
          changePageSizeFunc={this.onChangePageSize}
          onSearchKeyFunc={this.onSearchKey}
          displayMode={displayMode}
          changeDisplayMode={this.changeDisplayMode}
          selectedItemsLength={selectedItems.length}
          onHandlerDelete={() => {
            if (window.confirm("Bạn có chắc chắn muốn xóa bản ghi này?")) {
              this.onHandlerDelete();
            }
          }}
        />
        <AddDiscount
          title={<IntlMessages id="promotion-add" />}
          isOpen={show.add}
          toggle={() => {
            this.toggle("add");
          }}
          onSubmit={this.onHandlerAdd}
          data_dynamic_form={data_dynamic_form}
          values={form}
          discountRange={discountRange}
          oneProduct={oneProduct}
          oneTypeProduct={oneTypeProduct}
          quantityProduct={quantityProduct}
          quantityTypeProduct={quantityTypeProduct}
          customerPoint={customerPoint}
          productGetProduct={productGetProduct}
          orderGetProduct={orderGetProduct}
          customerPointGetProduct={customerPointGetProduct}
          customerGroupDiscount={customerGroupDiscount}
          firstOrderDiscount={firstOrderDiscount}
          lengthData={lengthData}
          setting={show}
          onAddItem={this.onAddItem}
          onAddProduct={this.onAddProduct}
          onRemoveDiscount={this.onRemoveDiscount}
          onRemoveProduct={this.onRemoveProduct}
          onChange={this.onChangeForm}
          onChangeItem={this.onChangeItem}
          onChangeDynamicForm={this.onChangeDynamicForm}
        />
        <UpdateDiscount
          title={<IntlMessages id="promotion-update" />}
          isOpen={show.update}
          toggle={() => {
            this.toggle("update");
          }}
          setting={show}
          values={form}
          discountRange={discountRange}
          oneProduct={oneProduct}
          oneTypeProduct={oneTypeProduct}
          quantityProduct={quantityProduct}
          quantityTypeProduct={quantityTypeProduct}
          customerPoint={customerPoint}
          productGetProduct={productGetProduct}
          orderGetProduct={orderGetProduct}
          customerPointGetProduct={customerPointGetProduct}
          customerGroupDiscount={customerGroupDiscount}
          firstOrderDiscount={firstOrderDiscount}
          onAddItem={this.onAddItem}
          onAddProduct={this.onAddProduct}
          onRemoveDiscount={this.onRemoveDiscount}
          onRemoveProduct={this.onRemoveProduct}
          onChange={this.onChangeForm}
          onChangeItem={this.onChangeItem}
          data_dynamic_form={data_dynamic_form}
          onChangeDynamicForm={this.onChangeDynamicForm}
          onSubmit={this.onHandlerUpdate}
        />
        {data.length === 0 ? (
          <Card className="mt-4 mb-4 mh-53vh">
            <CardBody>Chưa có dữ liệu...</CardBody>
          </Card>
        ) : (
          <>
            <Row className="content-page__row d-none d-md-flex">
              <Col
                xs="12"
                sm="12"
                md="12"
                lg={show.view && displayMode === "thumblist" ? 6 : 12}
                xl={show.view && displayMode === "thumblist" ? 6 : 12}
              >
                {data?.length ? (
                  displayMode === "thumblist" ? (
                    <>
                      {data?.map((item, idx) => (
                        <ListItemLeftForm
                          onClickedItem={this.onClickedItem}
                          onUpdate={this.onClickedUpdate}
                          onDelete={this.onClickedDelete}
                          onChangeCheckbox={this.onClickedCheckbox}
                          isDisabledUpdate={!isU(ROLE_ALIAS)}
                          isDisabledDelete={!isD(ROLE_ALIAS)}
                          selectedItems={selectedItems}
                          setting={show}
                          key={idx}
                          idx={idx}
                          item={item}
                          productMap={productMap} // <-- Truyền Map vào
                          categoryMap={categoryMap} // <-- Truyền Map vào
                        />
                      ))}
                      <Pagination
                        currentPage={page.currentPage}
                        totalPage={page.totalPage}
                        onChangePage={(i) => this.onChangePage(i)}
                      />
                    </>
                  ) : (
                    <div></div>
                  )
                ) : (
                  <Card className="d-flex justify-content-center align-items-center">
                    <CardBody>Chưa có dữ liệu...</CardBody>
                  </Card>
                )}
              </Col>
              {show.view ? (
                <Col xs="12" sm="12" md="12" lg="6" xl="6">
                  {/* <ContentDisplay
                                        // data_dynamic_form={data_dynamic_form}
                                        values={form}
                                    /> */}
                </Col>
              ) : null}
            </Row>
          </>
        )}
        <PromotionApplicationMenu
          data={data_all}
          filter={currentFilter}
          filterData={this.filterData}
        />
        <Separator />
        <FooterPage>
          <FooterPromotion />
        </FooterPage>
      </div>
    );
  }
}

const mapStateToProps = ({ searchInput }) => {
  const { keyword: searchKeyword } = searchInput;
  return { searchKeyword };
};

export default connect(mapStateToProps, {
  setSearchContext,
})(ContentComponent);
